import React from 'react'
import map from '../data/burgenland.topojson.js'
import * as d3 from 'd3-geo'
import * as topojson from 'topojson-client'
import ZoomMap from './ZoomMap'
import bezirksListe from '../data/bezirke'

export default ({
  pathProperties,
  overlayObjects,
  overlay,
  zoomToIso,
  setZoomToIso,
  className = '',
}) => {
  const width = 540
  const height = 540
  const projection = d3
    .geoMercator()
    .fitSize([width, height], topojson.feature(map, map.objects.gemeinden))
  const pathGenerator = d3.geoPath().projection(projection)

  const gemeinden = topojson
    .feature(map, map.objects.gemeinden)
    .features.map((d, i) => {
      const { children = null, ...pathProps } = pathProperties(
        parseInt(d.properties.iso)
      )

      return (
        <path key={`path_${i}`} d={pathGenerator(d)} {...pathProps}>
          {children}
        </path>
      )
    })
  const bezirke = bezirksListe.map((b, i) => {
    const d = topojson.merge(
      map,
      map.objects.gemeinden.geometries.filter(g => b.filter(g.properties.iso))
    )

    return (
      <path
        key={`path_${i}`}
        className={zoomToIso == b.zoomToIso ? 'selected' : ''}
        d={pathGenerator(d)}
      />
    )
  })

  const bundeslaender = topojson
    .feature(map, map.objects.bundeslaender)
    .features.map((d, i) => <path key={`path_${i}`} d={pathGenerator(d)} />)

  const overlay_gemeinden = overlayObjects
    ? topojson
        .feature(map, map.objects.gemeinden)
        .features.map((d, i) => overlayObjects(d, i, projection))
    : null

  const overlay_bezirke = overlayObjects
    ? topojson
        .feature(map, map.objects.bezirke)
        .features.map((d, i) => overlayObjects(d, i, projection))
    : null

  const selectedForZoom = topojson
    .feature(map, map.objects.bezirke)
    .features.find(d => d.properties.iso == zoomToIso)

  const bounds = selectedForZoom ? pathGenerator.bounds(selectedForZoom) : null

  return (
    <div className="svgContainer" tabIndex="0">
      <ZoomMap
        width={width}
        height={height}
        zoomTo={bounds}
        resetZoom={() => setZoomToIso()}
        className={className}
      >
        <g className="gemeinde">{gemeinden}</g>
        <g className="bezirk">{bezirke}</g>
        <g className="bundesland">{bundeslaender}</g>
        {overlay_gemeinden && (
          <g className="overlay_gemeinde">{overlay_gemeinden}</g>
        )}
        {overlay_bezirke && <g className="overlay_bezirk">{overlay_bezirke}</g>}
        {overlay && (
          <g className="overlay">
            {overlay({ map, pathGenerator, projection })}
          </g>
        )}
      </ZoomMap>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Map.js